import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledMessageBoxContainer = styled.div`
  width: 100%;
  display: flex;
  background-color: ${theme.colors.purple_5};
  justify-content: center;
  padding: 32px 0 32px 0;
  border-radius: 15px;
`;
